import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InputFields from '../components/InputFields';
import { useAddGrocery, useUpdateGrocery } from '../hooks/hooks';
import { showSuccessToast } from '../components/common';
import { useLocation, useNavigate } from 'react-router-dom';

function AddGroceriesPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isEdit = location.state?.isEdit || false;
  const isEditItem = location.state?.isEditItem;
  const openStockPanel = location.state?.openStockPanel || false;

  const [inputValue, setInputValue] = useState({
    name: "",
    unitType: "",
    stockQuantity: "",
    stockUnit: "",
    stockThreshold: "",
    stockThresholdUnit: ""
  });

  const [Error, setError] = useState({
    name: "",
    unitType: "",
    stockQuantity: "",
    stockUnit: "",
    stockThreshold: "",
    stockThresholdUnit: "",
    all: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  // Stock update panel state
  const [newStockQuantity, setNewStockQuantity] = useState('');
  const [newStockUnit, setNewStockUnit] = useState('');
  const [stockOpError, setStockOpError] = useState({ newStockQuantity: "", newStockUnit: "" });
  const [isAdding, setIsAdding] = useState(true);

  const unitTypeList = [
    { key: 'KGS', name: 'કિગ્રા (KGS)' },
    { key: 'Gram', name: 'ગ્રામ (Gram)' },
    { key: 'Liter', name: 'લિટર (Liter)' },
    { key: 'ML', name: 'મિલીલીટર (ML)' },
    { key: 'Pieces', name: 'નંગ (Pieces)' },
    { key: 'Per_Person', name: 'માણસો દીઠ (Per Person)' },
    { key: 'box', name: 'બોક્સ (Box)'}
  ];

  const { mutate: addgrocery } = useAddGrocery();
  const { mutate: updategrocery } = useUpdateGrocery();

  useEffect(() => {
    if (isEdit && isEditItem) {
      setInputValue({
        name: isEditItem.name || "",
        unitType: isEditItem.unitType || '',
        stockThreshold : isEditItem.stockThreshold || '',
        stockThresholdUnit : isEditItem.stockThresholdUnit || ''
      });
    }
  }, [isEdit, isEditItem]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value.toString(),
    });
    setError({
      ...Error,
      name: "",
      image: "",
      unitType: "",
      stockQuantity: "",
      stockUnit: "",
      stockThreshold: "",
      stockThresholdUnit: "",
      all: "",
    });
  };

  const onSubmit = () => {
    if (inputValue.name.toString().trim() === "") {
      setError({ ...Error, name: t('Groceries_Name_Er') });
      return;
    }

    if (inputValue.unitType.toString().trim() === "") {
      setError({ ...Error, unitType: t('Unit_Err') });
      return;
    }

    let formData = new FormData();
    formData.append("name", inputValue.name);
    formData.append("unitType", inputValue.unitType);
    formData.append("stockThreshold", inputValue.stockThreshold);
    formData.append("stockThresholdUnit", inputValue.stockThresholdUnit);

    setIsLoading(true);
    if (isEdit && isEditItem?._id) {
      formData.append("id", isEditItem._id);
      updategrocery(formData, {
        onSuccess: (res) => {
          showSuccessToast(res?.data?.message);
          setIsLoading(false);
          navigate('/groceries', { replace: true });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response?.data?.error });
        },
      });
    } else {
      addgrocery(formData, {
        onSuccess: (res) => {
          showSuccessToast(res?.data?.message);
          setIsLoading(false);
          navigate('/groceries', { replace: true });
        },
        onError: (err) => {
          setIsLoading(false);
          setError({ ...Error, all: err.response?.data?.error });
        },
      });
    }
  };

  const stockLogs = Array.isArray(isEditItem?.stockLogs)
    ? [...isEditItem.stockLogs].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    : [];

  const formatDateTime = (iso) => {
    try {
      const d = new Date(iso);
      return d.toLocaleString();
    } catch {
      return iso;
    }
  };

  const getUnitTypes = (unitType) => {
    switch (unitType.toLowerCase()) {
      case 'gram':
        return 'ગ્રામ (Gram)';
      case 'kgs':
        return 'કિગ્રા (KGS)';
      case 'liter':
        return 'લિટર (Liter)';
      case 'ml':
        return 'મિલીલીટર (ML)';
      case 'pieces':
        return 'નંગ (Pieces)';
      default:
        return unitType;
    }
  }

  const getEnglishUnit = (translatedUnit) => {
    translatedUnit = translatedUnit.trim();
    switch (translatedUnit) {
      case 'ગ્રામ':
        return 'Gram';
      case 'કિગ્રા':
        return 'KGS';
      case 'લિટર':
        return 'Liter';
      case 'મિલીલીટર':
        return 'ML';
      case 'નંગ':
        return 'Pieces';
      default:
        return translatedUnit;
    }
  };

  const calculateNewStock = (operation) => {
    if (!isEditItem?.stockQuantity || !isEditItem?.stockUnit || !newStockUnit || !newStockQuantity) {
      let convertedQuantity = newStockQuantity;
      let convertedUnit = newStockUnit.toString().toLowerCase();
      if (convertedUnit === "gram" && newStockQuantity >= 1000) { convertedQuantity = (newStockQuantity / 1000); convertedUnit = "KGS"; }
      else if (convertedUnit === "ml" && newStockQuantity >= 1000) { convertedQuantity = (newStockQuantity / 1000); convertedUnit = "Liter"; }
      else if (convertedUnit === "kgs" && newStockQuantity < 1) { convertedQuantity = (newStockQuantity * 1000); convertedUnit = "Gram"; }
      else if (convertedUnit === "liter" && newStockQuantity < 1) { convertedQuantity = (newStockQuantity * 1000); convertedUnit = "ML"; }
      const finalQuantity = convertedQuantity % 1 === 0 ? convertedQuantity : Number(convertedQuantity).toFixed(3);
      return `${finalQuantity} ${getUnitTypes(convertedUnit)}`;
    }

    let currentQuantity = Number(isEditItem.stockQuantity);
    let newQuantity = Number(newStockQuantity);
    let finalQuantity;

    const unitFrom = isEditItem.stockUnit.toString().toLowerCase();
    const unitTo = newStockUnit.toString().toLowerCase();

    if (unitFrom === "kgs" && unitTo === "gram") newQuantity = newQuantity / 1000;
    else if (unitFrom === "gram" && unitTo === "kgs") newQuantity = newQuantity * 1000;
    else if (unitFrom === "liter" && unitTo === "ml") newQuantity = newQuantity / 1000;
    else if (unitFrom === "ml" && unitTo === "liter") newQuantity = newQuantity * 1000;

    if (operation === "+") finalQuantity = currentQuantity + newQuantity; else { finalQuantity = currentQuantity - newQuantity; if (finalQuantity < 0) finalQuantity = 0; }

    if (unitFrom === "gram" && finalQuantity >= 1000) return (finalQuantity / 1000).toFixed(3) + " " + getUnitTypes("KGS");
    if (unitFrom === "ml" && finalQuantity >= 1000) return (finalQuantity / 1000).toFixed(3) + " " + getUnitTypes("Liter");
    if (unitFrom === "kgs" && finalQuantity < 1) return (finalQuantity * 1000).toFixed(0) + " " + getUnitTypes("Gram");
    if (unitFrom === "liter" && finalQuantity < 1) return (finalQuantity * 1000).toFixed(0) + " " + getUnitTypes("ML");

    return (finalQuantity % 1 === 0 ? finalQuantity : finalQuantity.toFixed(2)) + " " + getUnitTypes(unitFrom);
  };

  const handleStockSubmit = () => {
    if (!newStockQuantity.toString().trim()) { setStockOpError({ ...stockOpError, newStockQuantity: t('Stock_Quantity_Er') }); return; }
    if (!newStockUnit.toString().trim()) { setStockOpError({ ...stockOpError, newStockUnit: t('Unit_Err') }); return; }

    const stock = isAdding ? calculateNewStock("+") : calculateNewStock("-");
    const totalStock = stock.split(" ")[0] ? Number(stock.split(" ")[0]) : '';
    const totalStockUnit = stock.split(" ")[1] ? getEnglishUnit(stock.split(" ")[1]) : '';

    let formData = new FormData();
    formData.append("name", isEditItem.name);
    formData.append("unitType", isEditItem.unitType);
    formData.append("stockThreshold", isEditItem.stockThreshold);
    formData.append("stockThresholdUnit", isEditItem.stockThresholdUnit);
    formData.append("stockQuantity", totalStock);
    formData.append("stockUnit", totalStockUnit);

    setIsLoading(true);
    formData.append("id", isEditItem._id);
    updategrocery(formData, {
      onSuccess: (res) => {
        showSuccessToast(res?.data?.message);
        setIsLoading(false);
        setNewStockQuantity('');
        setNewStockUnit('');
        setIsAdding(true);
        setStockOpError({ newStockQuantity: "", newStockUnit: "" });
        navigate('/groceries', { replace: true });
      },
      onError: (err) => {
        setIsLoading(false);
        setStockOpError({ ...stockOpError, all: err.response?.data?.error });
      },
    });
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-orange-100">
      <div className=" mx-auto px-6 py-6">
        <div className="mb-8">
          <div className="flex items-center justify-between gap-4">
            <div>
              <h1 className="text-3xl font-bold mb-2 text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-700">
                {isEdit ? t('update_groceries') : t('add_new_groceries')}
              </h1>
              <p className="text-gray-600">
                {isEdit ? t('update_grocery_info') : t('add_new_grocery_info')}
              </p>
            </div>
            <div className="flex items-center gap-2">
              <button
                onClick={() => navigate(-1)}
                className="inline-flex items-center px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium rounded-lg transition-all"
              >
                <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                </svg>
                {t('Back')}
              </button>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-2xl shadow-card p-6 lg:col-span-2">
            <div className="space-y-6">
              <div>
                <label className="text-sm font-medium text-gray-700 mb-2 block">
                  {t('groceries_name')}
                </label>
                <InputFields
                  name="name"
                  label="groceries name"
                  type="text"
                  placeholder={t('pls_groceries_name')}
                  isHideLabel="false"
                  isFixedLabel="true"
                  disabled={isLoading}
                  handleChange={(e) => handleChange(e)}
                  value={inputValue?.name}
                  className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50"
                />
                {Error?.name && <div className="text-red-500 text-sm mt-1">{Error?.name}</div>}
              </div>

              <div>
                <label className="text-sm font-medium text-gray-700 mb-3 block">
                  Stock Threshold
                </label>
                <div className="grid grid-cols-3 gap-4">
                  <div className="col-span-1">
                    <label className="text-xs font-medium text-gray-600 mb-1 block">
                      {t('stockThreshold')}
                    </label>
                    <InputFields
                      name="stockThreshold"
                      label="stockThreshold"
                      type="text"
                      placeholder={t('stockThreshold')}
                      isHideLabel="false"
                      isFixedLabel="true"
                      disabled={isLoading}
                      handleChange={(e) => handleChange(e)}
                      value={inputValue?.stockThreshold}
                      className="w-full px-3 py-2 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 text-sm"
                    />
                    {Error?.stockThreshold && <div className="text-red-500 text-xs mt-1">{Error?.stockThreshold}</div>}
                  </div>

                  <div className="col-span-2">
                    <label className="text-xs font-medium text-gray-600 mb-1 block">
                      {t('stockThresholdUnit')}
                    </label>
                    <div className="relative">
                      <select
                        name="stockThresholdUnit"
                        value={inputValue.stockThresholdUnit}
                        onChange={handleChange}
                        placeholder="Select option"
                        className="w-full px-3 py-2 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 appearance-none cursor-pointer pr-8 text-sm"
                      >
                        <option value="" disabled selected>
                          {t('select_options')}
                        </option>
                        {unitTypeList && unitTypeList.map((unit) => (
                          <option key={unit.key} value={unit.key}>
                            {unit.name}
                          </option>
                        ))}
                      </select>
                      <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                    </div>
                    {Error?.stockThresholdUnit && <div className="text-red-500 text-xs mt-1">{Error?.stockThresholdUnit}</div>}
                  </div>
                </div>
              </div>

              <div>
                <label className="text-sm font-medium text-gray-700 mb-2 block">
                  {t('unitType')}
                </label>
                <div className="relative">
                  <select
                    name="unitType"
                    value={inputValue.unitType}
                    onChange={handleChange}
                    placeholder="Select option"
                    className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 appearance-none cursor-pointer pr-10"
                  >
                    <option value="" disabled selected>
                      {t('select_options')}
                    </option>
                    {unitTypeList && unitTypeList.map((unit) => (
                      <option key={unit.key} value={unit.key}>
                        {unit.name}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                    <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </div>
                {Error?.unitType && <div className="text-red-500 text-sm mt-1">{Error?.unitType}</div>}
              </div>

              {Error?.all && (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-red-400 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                    </svg>
                    <span className="text-red-700 text-sm">{Error?.all}</span>
                  </div>
                </div>
              )}

              {isEdit && (
                <div className="mt-6 border-t border-gray-200 pt-6">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-2">
                      <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                      </svg>
                      <h3 className="text-base font-semibold text-gray-900">Update Stock</h3>
                    </div>
                  </div>

                  <div className="flex items-center justify-between mb-4">
                    <span className="text-gray-700">{t('reduce_stock')}</span>
                    <button
                      onClick={() => isEditItem?.stockQuantity && setIsAdding(!isAdding)}
                      className={`${isAdding ? 'bg-green-500' : 'bg-red-500'} relative inline-flex items-center h-6 rounded-full w-11 transition ${!isEditItem?.stockQuantity ? 'cursor-not-allowed' : ''}`}
                      disabled={!isEditItem?.stockQuantity}
                    >
                      <span className="sr-only">Toggle stock operation</span>
                      <span className={`${isAdding ? 'translate-x-6' : 'translate-x-1'} inline-block w-4 h-4 transform bg-white rounded-full transition`} />
                    </button>
                    <span className="text-gray-700">{t('add_stock')}</span>
                  </div>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-medium text-gray-600 mb-1 block">{t('stockQuantity')}</label>
                      <InputFields
                        name="stockQuantity"
                        label="stockQuantity"
                        type="text"
                        placeholder={t('stockQuantity')}
                        isHideLabel="false"
                        isFixedLabel="true"
                        disabled={isLoading}
                        handleChange={(e) => { setNewStockQuantity(e.target.value ? Number(e.target.value) : ''); setStockOpError({ ...stockOpError, newStockQuantity: "", newStockUnit: "" }); }}
                        value={newStockQuantity}
                        className="w-full px-4 py-3 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50"
                      />
                      {stockOpError?.newStockQuantity && <div className='text-red-500  text-[14px]'>{stockOpError?.newStockQuantity}</div>}
                    </div>
                    <div>
                      <label className="text-xs font-medium text-gray-600 mb-1 block">{t('stockUnit')}</label>
                      <div className="relative">
                        <select
                          name="stockUnit"
                          value={newStockUnit}
                          onChange={(e) => { setNewStockUnit(e.target.value); setStockOpError({ ...stockOpError, newStockQuantity: "", newStockUnit: "" }); }}
                          placeholder="Select option"
                          className="w-full px-3 py-2 text-gray-900 bg-white border border-gray-200 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent transition-all duration-200 hover:bg-gray-50 appearance-none cursor-pointer pr-8 text-sm"
                        >
                          <option value="" disabled selected>{t('select_options')}</option>
                          {unitTypeList && unitTypeList.map((unit) => (
                            <option key={unit.key} value={unit.key}>{unit.name}</option>
                          ))}
                        </select>
                        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                          <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </div>
                      </div>
                      {stockOpError?.newStockUnit && <div className='text-red-500  text-[14px]'>{stockOpError?.newStockUnit}</div>}
                    </div>
                  </div>

                  {newStockQuantity && newStockUnit && newStockQuantity > 0 && newStockUnit !== '' && (
                    <div className="mt-3 text-sm text-gray-700">
                      {t('updatedStockLBL')}: {isAdding ? calculateNewStock('+') : calculateNewStock('-')}
                    </div>
                  )}

                  <button
                    className="mt-6 w-full h-[44px] rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold"
                    onClick={handleStockSubmit}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <svg aria-hidden="true" role="status" className="inline w-4 h-4 mr-2 text-white animate-spin" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                      </svg>
                    ) : (
                      isAdding ? t('add_stock') : t('reduce_stock')
                    )}
                  </button>
                </div>
              )}
            </div>

            <div className="mt-8 flex items-center gap-3 justify-end">
              <button
                onClick={() => navigate('/groceries')}
                className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-all duration-200 font-medium"
                disabled={isLoading}
              >
                {t('btnCancel')}
              </button>
              <button
                className="px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-all duration-200 flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed font-medium"
                onClick={onSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <svg
                      aria-hidden="true"
                      role="status"
                      className="inline w-4 h-4 mr-3 text-white animate-spin"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="#E5E7EB" />
                      <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" />
                    </svg>
                    Processing...
                  </>
                ) : (
                  isEdit ? t('btnUpdate') : t('btnSave')
                )}
              </button>
            </div>
          </div>

          <div className="space-y-6">
            {isEdit && (
              <div className="bg-white rounded-2xl shadow-card p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 10h16M4 14h16" />
                    </svg>
                    <h3 className="text-base font-semibold text-gray-900">Stock Logs</h3>
                    <span className="text-xs px-2 py-0.5 rounded bg-gray-100 text-gray-600 border border-gray-200">{stockLogs.length}</span>
                  </div>
                </div>

                <div className="max-h-[70vh] overflow-y-auto divide-y divide-gray-100">
                  {stockLogs.length === 0 ? (
                    <div className="p-8 text-center">
                      <div className="mx-auto mb-3 w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center">
                        <svg className="w-6 h-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
                        </svg>
                      </div>
                      <h4 className="text-sm font-medium text-gray-700">No stock logs found</h4>
                      <p className="text-xs text-gray-500">Stock changes will appear here when available.</p>
                    </div>
                  ) : (
                    stockLogs.map((log) => (
                      <div key={log._id} className="py-3">
                        <div className="flex items-start justify-between">
                          <div className="flex items-center gap-2">
                            <span className={`text-xs font-semibold px-2 py-1 rounded ${log.action === 'add' ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-red-50 text-red-700 border border-red-200'}`}>{log.action?.toUpperCase()}</span>
                            <span className="text-sm text-gray-700">
                              {log.changeQuantity} {log.changeUnit}
                            </span>
                            <span className="text-sm text-gray-400">•</span>
                            <span className="text-sm text-gray-700">{log.previousQuantity} {log.previousUnit} → {log.newQuantity} {log.newUnit}</span>
                          </div>
                          <div className="text-xs text-gray-500 whitespace-nowrap ml-4">{formatDateTime(log.createdAt)}</div>
                        </div>
                        {(log.context?.note || log.context?.mealTime || log.context?.orderId) && (
                          <div className="mt-2 text-xs text-gray-600">
                            {log.context?.note && <div className="truncate">{log.context.note}</div>}
                            {log.context?.mealTime && <div>Meal: {log.context.mealTime}</div>}
                            {log.context?.orderId && <div>Order: {log.context.orderId}</div>}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddGroceriesPage; 